import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { requestPasswordReset } from "../features/auth/authThunks.js";
import { clearPasswordResetState } from "../features/auth/authSlice.js";

import "../styles/password/forgot-password.css";

const ForgotPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    passwordResetLoading,
    passwordResetError,
    passwordResetSuccessMessage,
  } = useSelector((state) => state.auth);

  const [email, setEmail] = useState("");

  useEffect(() => {
    dispatch(clearPasswordResetState());
  }, [dispatch]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    dispatch(clearPasswordResetState());
    await dispatch(requestPasswordReset({ email }));
  };

  return (
    <div className="fp-page">
      <div className="fp-card">
        <div className="fp-header">
          <h1 className="fp-title">Recuperar contraseña</h1>
          <p className="fp-subtitle">
            Te enviaremos un email con un enlace para crear una nueva contraseña.
          </p>
        </div>

        <form className="fp-form" onSubmit={handleSubmit}>
          <div className="fp-field">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              required
              className="fp-input"
              autoComplete="email"
              placeholder="tu@email.com"
            />
          </div>

          <div className="fp-actions">
            <button
              type="submit"
              disabled={passwordResetLoading}
              className="fp-btn fp-btn--primary"
            >
              {passwordResetLoading ? "Enviando…" : "Enviar email"}
            </button>

            <button
              type="button"
              className="fp-btn fp-btn--ghost"
              onClick={() => navigate("/log-in")}
              disabled={passwordResetLoading}
            >
              Volver al login
            </button>
          </div>
        </form>

        {passwordResetSuccessMessage && (
          <div className="fp-message fp-message--success">
            {passwordResetSuccessMessage}
          </div>
        )}

        {passwordResetError && (
          <div className="fp-message fp-message--error">{passwordResetError}</div>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
